
import { onClickOutside } from '@vueuse/core';
import {
  computed,
  defineComponent,
  onMounted,
  PropType,
  ref,
  Ref,
  watch,
} from 'vue';
import { ICase, IError, IFolder } from '@/types/interfaces';
import DriveInput from '../modules/drive/components/UI/DriveInput.vue';
import AppLoader from './UI/AppLoader.vue';
import { useDriveStore } from '@/modules/drive/store/driveStore';
import NotificationService from '@/services/NotificationService';

export default defineComponent({
  components: {
    DriveInput,
    AppLoader,
  },
  props: {
    iCase: { type: Object as PropType<ICase>, required: true },
    mountErrorInfo: { type: Object as PropType<{title: string, error: string}>, required: false },
  },
  emits: ['close', 'open', 'clearMountErrorInfo'],
  setup(props, { emit }) {
    const modal = ref();
    const driveStore = useDriveStore();

    const isLoader: Ref<boolean> = ref(false);

    const caseTitle = ref(props.iCase?.title);
    const error = ref('');
    const percent: Ref<number> = ref(0);

    const skipValidationClear = ref(false);

    const disabled = computed(() => !!error.value || !caseTitle.value);

    function close() {
      emit('close');
    }

    function setError(prevTitle: string, errorTitle: string) {
      caseTitle.value = prevTitle;
      error.value = errorTitle;
    }
    function onUpdateRequest(per: number): void {
      percent.value = per;
    }

    function updateCase() {
      driveStore.currentCase.filesAmount = driveStore.currentCase.files.length;
      driveStore.currentCase.photosAmount = driveStore.currentCase.photos.length;

      isLoader.value = true;

      driveStore.updateCase(onUpdateRequest).then((res) => {
        const selectedCase = driveStore.cases.data.find((cas) => cas.id === driveStore.currentCase.id);
        isLoader.value = false;
        selectedCase!.title = res.results.data.title;
        driveStore.cases.data = [selectedCase as ICase, ...driveStore.cases.data.filter((cas) => cas.id !== driveStore.currentCase.id)];
        percent.value = 0;
      })
        .catch((e) => {
          const errorData = e?.response?.data;
          if (errorData) {
            if (errorData.errorKey === 'CASE_NAME_EXISTS') {
              driveStore.caseTitleValidation = 'Name is already taken';
              error.value = 'Name is already taken';
            } else {
              driveStore.caseTitleValidation = 'Something gone wrong';
              error.value = 'Something gone wrong';
            }
          } else {
            driveStore.caseTitleValidation = 'Something gone wrong';
            error.value = 'Something gone wrong';
          }
          isLoader.value = false;
          percent.value = 0;
        });
    }
    function renameCase(): void {
      if (disabled.value) {
        return;
      }
      // isLoader.value = true;

      driveStore.currentCase = props.iCase;
      driveStore.currentCase.title = caseTitle.value;

      updateCase();
      isLoader.value = false;
      close();
    }

    // function inCaseNameUniq(): boolean {
    //   if (!driveStore.currentCase) {
    //     return false;
    //   }
    //   return !!driveStore.mixedData?.find((case) => case?.case?.title === caseTitle.value);
    // }

    watch(() => caseTitle.value, () => {
      if (!caseTitle.value) {
        error.value = 'This filed is required';
      } else if (caseTitle.value.length < 4) {
        error.value = 'Folder name must be at least 4 characters long.';
      } else if (caseTitle.value.length > 255) {
        error.value = 'Folder name must be max 255 characters long.';
      // } else if (inCaseNameUniq()) {
      //   error.value = 'Name is already taken';
      } else if (!skipValidationClear.value) {
        error.value = '';
      } else {
        skipValidationClear.value = false;
      }
      caseTitle.value = caseTitle.value.replace(/(\r\n|\n|\r)/gm, '');
    });

    onClickOutside(modal, close);

    onMounted(() => {
      if (props.mountErrorInfo) {
        skipValidationClear.value = true;
        setError(props.mountErrorInfo.title, props.mountErrorInfo.error);
        emit('clearMountErrorInfo');
      }
    });

    return {
      modal,
      error,
      disabled,
      isLoader,
      close,
      renameCase,
      caseTitle,
    };
  },
});
